import { Dispatch, SetStateAction } from 'react';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert,
} from '@mui/material';
import { ConfirmType } from '@src/types/Notes';
import notesx from './NotesSx';
import FormattedAlias from '../Translations/FormattedAlias';
import useAlias from '@src/hooks/useAlias';

interface NotesConfirmDialogProps {
  error: boolean;
  confirmOpen: boolean;
  handleClose: () => void;
  confirmType: ConfirmType | string;
  deviceId: string;
  setError: Dispatch<SetStateAction<boolean>>;
  setConfirmOpen: Dispatch<SetStateAction<boolean>>;
  handleConfirm: () => void;
}

export default function NotesConfirmDialog({
  error,
  confirmOpen,
  handleClose,
  confirmType,
  deviceId,
  setError,
  setConfirmOpen,
  handleConfirm,
}: NotesConfirmDialogProps) {
  const alias = useAlias();
  let confirmText;
  if (confirmType === ConfirmType.CREATE) {
    confirmText = `${alias('Create note for')} ${deviceId}?`;
  } else if (confirmType === ConfirmType.CLEAR) {
    confirmText = `${alias('Are you sure want to remove all notes')}?`;
  } else {
    confirmText = `${alias('Are you sure want to remove this note')}?`;
  }

  return (
    <Dialog open={confirmOpen} onClose={handleClose}>
      <DialogContent>
        {error && (
          <Alert sx={notesx.alert} variant='outlined' severity='error'>
            <FormattedAlias id={'Note unable to be posted'} />.
          </Alert>
        )}
        <DialogContentText>{confirmText}</DialogContentText>
      </DialogContent>
      <DialogActions sx={notesx.dialogActions}>
        <Button
          size='small'
          onClick={() => {
            setError(false);
            setConfirmOpen(false);
          }}
        >
          <FormattedAlias id={'Cancel'} />
        </Button>
        <Button
          size='small'
          onClick={handleConfirm}
          autoFocus
          variant='contained'
        >
          <FormattedAlias id={'Confirm'} />
        </Button>
      </DialogActions>
    </Dialog>
  );
}
